import * as React from 'react';

import * as styles from './RateMark.css';

export interface IRateMarkProps {
  iconUrl: string;
  maxRate: string;
  rate: string;
}

export const RateMark: React.FC<IRateMarkProps> = ({ iconUrl, maxRate, rate }) => {
  return (
    <div className={styles['container']} data-testid="RateMark">
      <div className={styles['icon']} style={{ backgroundImage: `url("${iconUrl}")` }} aria-hidden="true" />
      <div className={styles['rate']}>{rate}</div>
      <div className={styles['rate-from']}>из {maxRate}</div>
    </div>
  );
};
